import { AuditEvent } from '../types/audit';
import { api } from './api';

interface PaginatedAuditResult {
  data: AuditEvent[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

interface AuditFilters {
  search?: string;
  userName?: string;
  actionName?: string;
  documentName?: string;
  dateStart?: string;
  dateEnd?: string;
  page?: number;
  pageSize?: number;
}

class AuditService {
  async getAuditEvents(): Promise<AuditEvent[]> {
    const response = await api.get('/documents/audit');
    
    // Ordenar por data em ordem decrescente (mais recente primeiro)
    return response.data.sort((a: AuditEvent, b: AuditEvent) => 
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  async getFilteredAuditEvents(filters: AuditFilters = {}): Promise<PaginatedAuditResult> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.userName) params.append('userName', filters.userName);
    if (filters.actionName) params.append('actionName', filters.actionName);
    if (filters.documentName) params.append('documentName', filters.documentName);
    if (filters.dateStart) params.append('dateStart', filters.dateStart);
    if (filters.dateEnd) params.append('dateEnd', filters.dateEnd);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.pageSize) params.append('pageSize', filters.pageSize.toString());

    const response = await api.get(`/documents/audit/filtered?${params.toString()}`);
    return response.data;
  }

  async getAuditEventById(id: string): Promise<AuditEvent> {
    const response = await api.get(`/documents/audit/${id}`);
    return response.data;
  }
}

export const auditService = new AuditService(); 